export const KB_LANGS = ['en', 'ru', 'es', 'de'] as const;

export type KbLang = (typeof KB_LANGS)[number];

// The hub serves en/ru/es/de directly; for any other UI locale the param is
// omitted so the hub falls back to the market default language.
export const getKbLang = (locale?: string | null): KbLang | undefined => {
  if (!locale) return undefined;

  const base = locale.toLowerCase().split(/[-_]/)[0];

  return (KB_LANGS as readonly string[]).includes(base)
    ? (base as KbLang)
    : undefined;
};
